import Axios from "axios";
import { BaseService } from "./BaseService";
import { UsuarioLogado } from "@/model/UsuarioLogado";
import { UsuarioCadastro } from "@/model/Usuario";
import { Idioma } from "@/model/Idioma";
import { Constantes } from "@/Util/Constantes";
import store from "@/store";
import { Utilidades } from "@/Util/Utilidades";
BaseService.loadAxios();

const RESOURCE_NAME = "/auth/login";

export interface Login {
    usuario: string;
    clave_actual: string;
    clave: string;
    confirmacion_clave: string;
    token: string,
    url: string
}

export class AuthService {
    public static async checkToken() {
        return await Axios.get("/admin")
    }

    public static async getAmbiente() {
        return await Axios.get("/ambiente")
    }

    public static async revalidarToken() {
        return await Axios.get("/auth/revalidar")
    }

    public static async loginAsync(login: Login) {
        return await Axios.post(RESOURCE_NAME, login);
    }

    public static async linkRecuperarClaveAsync(email) {
        return await Axios.get("/usuario/recuperarClave/" + email);
    }

    public static async recuperarClaveAsync(login: Login) {
        return await Axios.post("/usuario/recuperarClave", login);
    }

    public static async cambiarClaveAsync(login: Login) {
        return await Axios.post("/usuario/cambiarClave", login);
    }

    public static async registrarAsync(usuario: UsuarioCadastro) {
        return await Axios.post("/usuario/registrar", usuario);
    }

    public static async activarUsuarioAsync(token: string) {
        return await Axios.get("/usuario/activar/" + token);
    }

    public static getUsuario(): UsuarioLogado {
        //return localStorage.getItem("login") && localStorage.getItem("token");
        //return store.state.Login;
        return JSON.parse(localStorage.getItem("usuario")) as UsuarioLogado;
    }

    public static logout() {
        let usuario = this.getUsuario();

        let movil = usuario.es_movil;

        localStorage.removeItem("usuario");
        Utilidades.deleteCookie(Constantes.SESSION_COOKIE);
        //window.location.href = "/login";  

        if (movil === true) {
            window.location.href = "/login?movil=true";
        }
        else {
            window.location.href = "/";
        }
    }

    public static grabarLogin(usuario) {
        localStorage.setItem("usuario", JSON.stringify(usuario));
        this.updateVersion();
        // store.commit("setSessionTimeout", this.getUsuario().session_timeout);
        Utilidades.deleteCookie(Constantes.SESSION_COOKIE);
        Utilidades.setCookie(Constantes.SESSION_COOKIE, this.getUsuario().cookie, this.getUsuario().session_timeout);
    }

    public static getTareas(): Array<string> {
        var usuario = this.getUsuario();
        try {

            if (usuario) {
                var token = usuario.token.split(".")[1];
                var tareas = JSON.parse(atob(token));

                if (tareas)
                    return tareas.role;
                else
                    return [];
            }
            else {
                return [];
            }
        }
        catch {
            return [];
        }
    }

    public static getIdUsuario(): string {
        return this.getUsuario()?.id;
    }

    public static updateVersion() {
        let usuario = this.getUsuario();
        // usuario.version = Constantes.VERSION;
        usuario.version = store.state.version;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    public static updateEjercicioEmpresaSeleccionado(id: string) {
        let usuario = this.getUsuario();
        usuario.id_empresa_ejercicio_seleccionado = id;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    public static updateEmpresaSeleccionada(id: string) {
        let usuario = this.getUsuario();
        usuario.id_empresa_seleccionado = id;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    public static updatePerfilSeleccionado(id: string) {
        let usuario = this.getUsuario();
        usuario.id_perfil_seleccionado = id;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    public static updateToken(token: string) {
        let usuario = this.getUsuario();
        usuario.token = token;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    public static updateIdioma(idioma: Idioma) {
        let usuario = this.getUsuario();
        usuario.id_idioma = idioma.id_idioma;
        usuario.formato_fecha = idioma.formato_fecha;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    public static updateLanguage(cod) {
        let usuario = this.getUsuario();
        usuario.language = cod;

        localStorage.setItem("usuario", JSON.stringify(usuario));
    }



    public static esMovil() {
        let usuario = this.getUsuario();

        usuario.es_movil = true;
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }
}